// import React, { useState, useEffect } from "react";
// import { Button, Card, Modal, Form } from "react-bootstrap";

// const Recommendation = ({isProfile = false }) => {
//   const getStoredData = () => {
//     const storedData = localStorage.getItem("recommendationData");
//     return storedData
//       ? JSON.parse(storedData)
//       : { id: 1, student: "John Doe", recommendation: "Work on time management skills." };
//   };

//   const [data, setData] = useState(getStoredData);
//   const [showModal, setShowModal] = useState(false);
//   const [modalType, setModalType] = useState("add");
//   const [formData, setFormData] = useState({
//     id: null,
//     page: "StudentAcademicsAssessment",
//     studentId: slug,
//     instructorId: profile.id,
//     instructorNote: "",
//   });

//   async function GetData() {
//     getNotesData(slug, profile.id, "StudentAcademicsAssessment")
//       .then((allData) => {
//         // Veriyi slug'a göre filtreleyin
//         // const filteredData = allData.filter((row) => row.studentId === slug);
//         setData(filteredData.length>0 && filteredData[0]);
//       })
//       .catch((error) => {
//         console.error("Error fetching data:", error);
//       });
//   }

//   useEffect(() => {
//     GetData();
//   }, [slug]);

//   const handleOpenModal = (type) => {
//     if (type === "edit" && data?.id) {
//       setModalType("edit");
//       setFormData({
//         id: data.id,
//         page: "StudentAcademicsAssessment",
//         studentId: slug,
//         instructorId: profile.id,
//         instructorNote: data.instructorNote || "",
//       });
//     } else {
//       setModalType("add");
//       setFormData({
//         page: "StudentAcademicsAssessment",
//         studentId: slug,
//         instructorId: profile.id,
//         instructorNote: "",
//       });
//     }
//     setShowModal(true);
//   };

//   const handleCloseModal = () => setShowModal(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSave = async () => {
//     try {
//       if (modalType === "edit") {
//         await updateData(formData);
//       } else {
//         await addData(formData);
//       }
//       GetData();
//       handleCloseModal();
//     } catch (error) {
//       console.error("Error saving data:", error);
//       alert("An error occurred while saving the data.");
//     }
//   };

//   const handleDelete = async (id) => {
//     const choice = window.confirm("Are You Sure?");
//     if (choice) {
//       try {
//         await deleteIdData(id);
//         GetData();
//       } catch (error) {
//         console.error("Error deleting data:", error);
//         alert("An error occurred while deleting the data.");
//       }
//     }
//     handleCloseModal();
//   };

//   return (
//     <div className="container mt-4">
//       <Card className="shadow-lg">
//         <Card.Body>
//           <Card.Title className="text-center text-primary fw-bold">🎓 Student Recommendation</Card.Title>
//           <div className="mt-3">
//             <h5>{data.student}</h5>
//             <p><strong>Goals/Recommendation:</strong></p>
//             <p>{data.recommendation}</p>
//           </div>
//           {!isProfile && (
//           <div className="d-flex justify-content-end mt-3">
//             <Button variant="info" size="sm" onClick={handleOpenModal}>
//               ➕ Edit Recommendation
//             </Button>
//           </div>
//           )}
//         </Card.Body>
//       </Card>

//       <Modal show={showModal} onHide={handleCloseModal}>
//         <Modal.Header closeButton>
//           <Modal.Title>{modalType === "edit" ? "Update Recommendation" : "Add Recommendation"}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group className="mb-2">
//               <Form.Label>Recommendation</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={4}
//                 name="instructorNote"
//                 value={formData.instructorNote || ""}
//                 onChange={handleChange}
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseModal}>
//             Close
//           </Button>
//           <Button variant="primary" onClick={handleSave}>
//             {data && data?.id ? "Update" : "Save"}
//           </Button>
//           {modalType === "edit" && (
//             <Button variant="danger" onClick={() => handleDelete(formData.id)}>
//               Delete
//             </Button>
//           )}
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default Recommendation;
import React, { useState, useEffect } from "react";
import { Button, Card, Modal, Form } from "react-bootstrap";
import style from "./academicAssessment.module.css";
import { useAuth } from "../../../../../usercontext";
import {
  getNotesData,
  addData,
  updateData,
  deleteIdData,
} from "../../../../../lib/pagenotes";

const Recommendation = ({ slug, isProfile = false, isStudent=false }) => {
  const { profile, setProfile } = useAuth();
  const [data, setData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("add");
  const [formData, setFormData] = useState({
    id: null,
    page: "StudentAcademicsAssessment",
    studentId: slug,
    instructorId: profile.id,
    instructorNote: "",
  });

  async function GetData() {
    getNotesData(slug, profile.id, "StudentAcademicsAssessment")
      .then((allData) => {
        // Veriyi slug'a göre filtreleyin
        const filteredData = allData.filter((row) => row.studentId === slug);
        setData(filteredData.length>0 && filteredData[0]);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  useEffect(() => {
    GetData();
  }, [slug]);

  const handleOpenModal = (type) => {
    if (type === "edit" && data?.id) {
      setModalType("edit");
      setFormData({
        id: data.id,
        page: "StudentAcademicsAssessment",
        studentId: slug,
        instructorId: profile.id,
        instructorNote: data.instructorNote || "",
      });
    } else {
      setModalType("add");
      setFormData({
        page: "StudentAcademicsAssessment",
        studentId: slug,
        instructorId: profile.id,
        instructorNote: "",
      });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      if (modalType === "edit") {
        await updateData(formData);
      } else {
        await addData(formData);
      }
      GetData();
      handleCloseModal();
    } catch (error) {
      console.error("Error saving data:", error);
      alert("An error occurred while saving the data.");
    }
  };

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      try {
        await deleteIdData(id);
        GetData();
      } catch (error) {
        console.error("Error deleting data:", error);
        alert("An error occurred while deleting the data.");
      }
    }
    handleCloseModal();
  };

  return (
    <div className="container">
      <Card className={`${style.card} shadow-lg`}>
        <Card.Body className={`${style.cardBody}`}>
        {!isProfile ? (
          <div className="d-flex justify-content-between align-items-center">
            <Card.Title className="text-center text-primary fw-bold">🎓 GOALS</Card.Title>
            
           {!isStudent && <Button variant="info" size="sm" onClick={() => handleOpenModal(data?.id ? "edit" : "add")}>
              ➕ {data?.id ? "Edit Recommendation" : "Add Recommendation"}
            </Button>}
          </div>
          ):(
          <Card.Title className="text-center text-primary fw-bold">🎓 GOALS</Card.Title>
          )}
          <div className="mt-3">
            <h5>{data ? (data?.id ? data.student : "No data found") : "Loading..."}</h5>
            <p>
              <strong>Goals/Recommendation:</strong>
            </p>
            {data && data?.id ? (
              <p>{data?.instructorNote || "No recommendation available."}</p>
            ) : (
              <p>No recommendation available.</p>
            )}
          </div>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{modalType === "edit" ? "Update Recommendation" : "Add Recommendation"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>Recommendation</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="instructorNote"
                value={formData.instructorNote || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {data && data?.id ? "Update" : "Save"}
          </Button>
          {modalType === "edit" && (
            <Button variant="danger" onClick={() => handleDelete(formData.id)}>
              Delete
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Recommendation;